// extracted by css-extract-rspack-plugin
export default {"rowBox":"rowBox-zjeBsb","colBox":"colBox-GSA5YY","titleBox":"titleBox-zj_zaw","content":"content-XDtO4c"};